import React, {useState, useCallback} from 'react';
import {Map, GoogleApiWrapper, Marker, InfoWindow} from 'google-maps-react';
import {Box, Typography} from '@material-ui/core';
import colors from '../../../../theme/colors';

/**
 * Read-only Google Map showing a single pickup point marker.
 *
 * Rendered only when the pickup point has usable coordinates; the parent
 * (PickupPointCard) is responsible for that check so this stays presentational.
 */
const PickupPointMap = ({google, latitude, longitude, name, address, zoom = 15}) => {
	const [showInfoWindow, setShowInfoWindow] = useState(false);
	const [activeMarker, setActiveMarker] = useState(null);

	const center = {lat: Number(latitude), lng: Number(longitude)};

	const handleMarkerClick = useCallback((props, marker) => {
		setActiveMarker(marker);
		setShowInfoWindow(true);
	}, []);

	const handleInfoWindowClose = useCallback(() => {
		setActiveMarker(null);
		setShowInfoWindow(false);
	}, []);

	return (
		<Box
			style={{
				width: '100%',
				height: '280px',
				position: 'relative',
				borderRadius: 4,
				overflow: 'hidden',
			}}
		>
			<Map
				google={google}
				zoom={zoom}
				center={center}
				initialCenter={center}
				streetViewControl={false}
				mapTypeControl={false}
				fullscreenControl={false}
				keyboardShortcuts={false}
				scrollwheel={false}
				zoomControl={true}
				style={{width: '100%', height: '280px'}}
			>
				<Marker
					position={center}
					name={name}
					title={name}
					onClick={handleMarkerClick}
				/>
				<InfoWindow
					marker={activeMarker}
					visible={showInfoWindow}
					onClose={handleInfoWindowClose}
				>
					<Box style={{maxWidth: 220}}>
						<Typography variant="body2" style={{fontWeight: 'bold', color: colors.darkBold}}>
							{name || 'Pickup point'}
						</Typography>
						{address && (
							<Typography variant="caption" style={{color: colors.darkRegular}}>
								{address}
							</Typography>
						)}
					</Box>
				</InfoWindow>
			</Map>
		</Box>
	);
};

export default GoogleApiWrapper({
	apiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
})(PickupPointMap);
